import { OnDestroy, OnInit, Component } from '@angular/core';
import { ValidatorService } from 'app/shared/services/validator.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { BsModalRef } from 'ngx-bootstrap';
import { IDtoSolicitudDinero } from 'app/shared/models/money/dto-solicitud-dineto.model';
import { MoneyService } from 'app/views/appviews/money.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { EmployeeService } from 'app/views/appviews/employee.service';
import { IDtoEmployeeBasicData } from 'app/shared/models/employee/dto-employee-basic-data.model';
import { Subject } from 'rxjs';
import { LiquidationService } from 'app/views/appviews/liquidation.service';
import { DemandService } from 'app/views/appviews/demand.service';
import { IDtoLawyerCost } from 'app/shared/models/legal/dto-lawyer-cost.model';
import { IDtoLawyer } from 'app/shared/models/legal/dto-lawyer.model';

@Component({
  selector: 'app-modal-request-money',
  styleUrls: ['modal-request-money.style.scss'],
  templateUrl: 'modal-request-money.template.html'
})
export class ModalRequestMoneyComponent implements OnDestroy, OnInit {
  /**Validadores */
  private validator = ValidatorService;
  private fsaFlags = [false];
  private flag = false;
  private errorMessages: any;
  /**Formularios */
  private form: FormGroup;
  private amount: number;
  private module: string;
  employee: IDtoEmployeeBasicData;
  employeeId: number;
  id: number;
  employeeIniId: number;
  onClose: Subject<number>;
  solicitudDinero: IDtoSolicitudDinero;
  user: string;
  lawyer: IDtoLawyer;
  constructor(private formBuilder: FormBuilder
    , private configGeneral: AppConfig
    , private bsModalRef: BsModalRef
    , private moneyService: MoneyService
    , private employeeService: EmployeeService
    , private spinner: NgxSpinnerService
    , private liquidationService: LiquidationService
    , private demandService: DemandService) {
    this.initializeForm();
  }
  ngOnDestroy(): void {
  }
  ngOnInit(): void {
    this.onClose = new Subject();
    this.obtenerDatosSolicitudDinero();
    if(this.user == 'lawyer') {
      this.getLawyer(this.employeeId);
    } else {
      this.getEmployee(this.employeeId);
    }
    //this.form.get('amount').setValue(this.amount);
  }
  private initializeForm() {
    this.form = this.formBuilder.group({
      amount: [this.amount, [Validators.required]]
    });
  }
  private submitForm(): void {
    if (this.form.valid) {
      this.sentRequestMoney();
    } else {
      this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'warning');
      this.configGeneral.touchedControls(this.form);
    }
  }
  private onCancel(): void {
    this.bsModalRef.hide();
  }
  private sentRequestMoney(): void {
    let dto = {} as IDtoSolicitudDinero;
    dto.modulo = this.module;
    dto.idRegistroModulo = this.id;
    dto.cantidad = this.form.value.amount;
    dto.idEmpleadoAutenticado = this.employeeIniId;
    dto.beneficiario = this.user == 'lawyer' ? this.lawyer.name : `${this.employee.firstName} ${this.employee.lastName} ${this.employee.secondLastName}`;
    dto.idClasificacionPago = 1;
    dto.cuenta = this.user == 'lawyer' ? this.lawyer.bankAccount : this.employee.bankAccount == null ? '' : this.employee.bankAccount;
    dto.clabe = this.user == 'lawyer' ? this.lawyer.interbankClabe : this.employee.interbankClabe == null ? '' : this.employee.interbankClabe;
    dto.idBanco = this.user == 'lawyer' ? +this.lawyer.bank : this.employee.bankId;
    dto.idTipoBeneficiario = 1;
    dto.requierePagoAnticipado = false;

    this.spinner.show()
    this.moneyService.agregarSolicitud(dto)
      .subscribe(
        (x) => {
          if (this.configGeneral.notificationSuccessError(x)) {
            this.onClose.next(this.form.value.amount);
          }
          this.spinner.hide();
        },
        (errMessage) => {
          this.spinner.hide();
          this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
  }
  private getEmployee(employeeId: number): void {
    this.spinner.show()
    this.employeeService.getBasicEmployeeData(employeeId)
      .subscribe(
        (x) => {
          if (this.configGeneral.notificationSuccessError(x)) {
            this.employee = x.data as IDtoEmployeeBasicData;
          }
          this.spinner.hide();
        },
        (errMessage) => {
          this.spinner.hide();
          this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
  }
  private getLawyer(employeeId: number): void {
    this.spinner.show()
    this.demandService.getLawyerById(employeeId)
      .subscribe(
        (x) => {
          this.lawyer = x;
          this.spinner.hide();
        },
        (errMessage) => {
          this.spinner.hide();
          this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
  }
  private obtenerDatosSolicitudDinero(): void {
    this.spinner.show()
    this.solicitudDinero = {} as IDtoSolicitudDinero;
    this.liquidationService.obtenerDatosSolicitudDinero(this.id, this.module)
      .subscribe(
        (x) => {
          if (x.isCorrect) {
            this.solicitudDinero = x.data as IDtoSolicitudDinero;
            this.form.get('amount').setValue(this.solicitudDinero.cantidad);
          } else {
            this.configGeneral.newToast('Error', x.message, 'error');
          }
          this.spinner.hide();
        },
        (errMessage) => {
          this.spinner.hide();
          this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
  }
}